module.exports = __webpack_public_path__ + "img/20_57.2fe2adb2.png";